<template>
  <span
    class="tw-inline-flex tw-h-8 tw-items-center tw-justify-between tw-rounded-2xl tw-border-none tw-bg-primary-grey-200 tw-pl-2 tw-pr-1.5"
  >
    <span class="tw-text-base tw-text-primary-grey-700">
      <span class="tw-font-bold">{{ props.label }}</span>
      <span class="tw-pl-1 tw-font-normal">{{ props.value }}</span>
    </span>
    <span
      v-if="props.withClose"
      role="button"
      class="tw-ml-2 tw-inline-flex tw-h-5 tw-w-5 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-bg-primary-grey-500 tw-text-white tw-transition-colors hover:tw-bg-primary-grey-400"
      @click="emitClick"
    >
      <ClIconTablerX height="16px" width="16px" />
    </span>
  </span>
</template>
<script setup lang="ts">
import { ClIconTablerX } from "../icons";

export interface ActiveFilterProps {
  label: string;
  value: string;
  withClose: boolean;
}

const props = withDefaults(defineProps<ActiveFilterProps>(), {
  withClose: true,
});

const emit = defineEmits<{
  (event: "remove"): void;
}>();

const emitClick = (): void => {
  emit("remove");
};
</script>
